import { useContext } from "react";
import SocketContext from "../contexts/SocketContext";

/**
 * Custom hook untuk menggunakan Socket.IO context
 * @returns {object} - Socket context dengan socket instance dan state
 */
export const useSocket = () => {
  const context = useContext(SocketContext);

  if (!context) {
    throw new Error("useSocket must be used within a SocketProvider");
  }

  return context;
};
